import { render } from "./BankIntegrationModal.vue?vue&type=template&id=6125c910&scoped=true"
import script from "./BankIntegrationModal.vue?vue&type=script&lang=js"
export * from "./BankIntegrationModal.vue?vue&type=script&lang=js"

import "./BankIntegrationModal.vue?vue&type=style&index=0&id=6125c910&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6125c910"]])

export default __exports__